/**
 * Gets a human-readable label for failed calls
 * @param {object} item - The call record object
 * @returns {string} Human-readable failure label
 */
export const getFailureLabel = (item) => {
    if (!item) return "Call Failed";

    // Check failure reason from top-level field
    const reason = (item.failure_reason || "").toLowerCase();
    if (reason.includes("voicemail")) return "Voicemail Detected";
    if (reason.includes("busy")) return "Busy Call";
    if (reason.includes("no-answer") || reason.includes("no answer")) return "No Answer call";
    if (reason.includes("canceled") || reason.includes("cancelled")) return "Call Cancel";
    if (reason.includes("hangup")) return "Call Failed";
    if (reason.includes("customer not connected") || item.type === "call_not_connect") return "Call Not Connect";

    // Deep parsing of call_initiation_failure payload
    try {
        if (item.call_initiation_failure) {
            const parsed = typeof item.call_initiation_failure === 'string'
                ? JSON.parse(item.call_initiation_failure)
                : item.call_initiation_failure;

            const body = parsed?.body?.[0];
            const status = body?.CallStatus || body?.SipResponseCode;
            const errMsg = (body?.ErrorMessage || "").toLowerCase();

            // Explicit check for invalid phone number
            //if (errMsg.includes("invalid phone number")) return "Invalid Number";

            if (typeof status === "string") {
                const statusLc = status.toLowerCase();
                if (statusLc.includes("busy")) return "Busy Call";
                if (statusLc.includes("no-answer") || statusLc.includes("no answer"))
                    return "Call Not Receive";
                if (statusLc.includes("cancel")) return "Call Cancel";
            }
        }
    } catch (err) {
        // Fallback if parsing fails
    }

    return "Call Failed";
};
